import { FilterOptionsCalendarEnum } from "@Enums/FilterOptionsCalendarEnum"
import { IRangeExtend } from "@Interfaces/IContentCelendar"
import { addDays } from "date-fns"

export const rangeDefault: IRangeExtend = {
  key: "selection",
  startDate: addDays(new Date(), -7),
  endDate: new Date(),
  activeOptionFilter: FilterOptionsCalendarEnum.lastWeek,
}
